import type { Channel } from '../type';

import type { ComparatorOptions } from './sortChannels';

export function compareByChannelNumber(a: Channel, b: Channel): number {
  if (isNumber(a.channelNumber) && isNumber(b.channelNumber)) {
    return a.channelNumber - b.channelNumber;
  }

  // to ensure stable sorting between channels with and without number
  return compareIfNotValid(isNumber(a.channelNumber), isNumber(b.channelNumber)) ?? 0;
}

export function compareByWatchCount(a: Channel, b: Channel, { mostWatchedChannels }: ComparatorOptions): number {
  const aWatchCount = mostWatchedChannels.get(a.id) ?? 0;
  const bWatchCount = mostWatchedChannels.get(b.id) ?? 0;

  return bWatchCount - aWatchCount;
}

export function compareByFavorite(a: Channel, b: Channel, { favoriteChannels }: ComparatorOptions): number {
  const aFavPosition = favoriteChannels.get(a.id);
  const bFavPosition = favoriteChannels.get(b.id);

  if (isNumber(aFavPosition) && isNumber(bFavPosition)) {
    return aFavPosition - bFavPosition;
  }

  // to ensure stable sorting between fav and non-fav
  return compareIfNotValid(isNumber(aFavPosition), isNumber(bFavPosition)) ?? 0;
}

function compareIfNotValid(aValid: boolean, bValid: boolean) {
  if (aValid && !bValid) {
    return -1;
  }

  if (!aValid && !bValid) {
    return 0;
  }

  if (!aValid && bValid) {
    return 1;
  }
}

function isNumber(number: number | undefined): number is number {
  return Number.isInteger(number);
}
